export default __webpack_public_path__ + "static/media/soy_fibro_squared.9cb67fda.png";